export default __webpack_public_path__ + "static/media/crop_pattern_winter.d88c613e.jpg";